import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Flex from '@decisiv/ui-components/lib/components/Flex';

import useDisableRareaStyles from './hooks/useDisableRareaStyles';

const Container = styled(Flex)`
  max-width: ${(props) => props.$maxWidth}px;
  width: 100%;
`;

/**
 * Page wrapper for KeyDS-based pages rendered inside the #rarea layout.
 *
 * Disables legacy .rarea CSS styles (which override KeyDS component styling)
 * and provides a column-direction Flex container with sensible defaults.
 *
 * Usage:
 *   <KeyDSPageContainer>
 *     <H1>My Page</H1>
 *     ...
 *   </KeyDSPageContainer>
 */
function KeyDSPageContainer({ children, maxWidth, padding, ...rest }) {
  useDisableRareaStyles();

  return (
    <Container
      flexDirection="column"
      padding={padding}
      $maxWidth={maxWidth}
      {...rest}
    >
      {children}
    </Container>
  );
}

KeyDSPageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.number,
  padding: PropTypes.number,
};

KeyDSPageContainer.defaultProps = {
  maxWidth: 1400,
  padding: 2,
};

export default KeyDSPageContainer;
